import { Dispatch } from "redux";
import { ApiConfig } from "../../../../../../config/ApiConfig";
import { createRequestActionTypes } from "../../../../../../utils/request-actions-helpers/createRequestActionTypes";
import { createRequestThunk, RequestThunkParameters } from "../../../../../../utils/request-actions-helpers/createRequestThunk";
import { AppStateWithData } from "../../../../../AppStateWithData";
import { DocumentUpdateInfo } from "../UpdateDocumentAdditionalData";
import { DocumentPermissionsRequest } from "../../../../../../models/DocumentPermissionRequest";
import { moveDocumentBetweenLanes } from "../moveLane/moveDocumentBetweenLanes";

export const updateDocumentPermissionActionTypes = createRequestActionTypes('UPDATE_DOCUMENT_PERMISSIONS')

export interface UpdateDocumentPermissionsAdditionalData {
    docId: string,
    isFullview?: boolean
    updateInfo?: DocumentUpdateInfo
}
type UpdateDocumentPermissionRequestBody = DocumentPermissionsRequest

export const updateDocumentPermissions = (config: ApiConfig) => (docId: string, permissionMoveOption: DocumentPermissionsRequest, isFullview?: boolean) => (dispatch: Dispatch, getState: () => AppStateWithData) => {
    const thunkParams: RequestThunkParameters<Document, UpdateDocumentPermissionRequestBody, UpdateDocumentPermissionsAdditionalData> = {
        method: 'PUT',
        url: `${config.API_URL}/content/permissions?docId=${encodeURIComponent(docId)}`,
        requestActionTypes: updateDocumentPermissionActionTypes,
        actionAdditionalData: {
            docId,
            isFullview
        },
        body: permissionMoveOption,
        processResultBeforeDispatch: (result: Document) => {
            if (config.refreshFeed) {
                config.refreshFeed()
            }
            if (config.updateItem) {
                config.updateItem(docId)
            }
            if (permissionMoveOption.moveLaneRequest) {
                dispatch<any>(moveDocumentBetweenLanes(config)(permissionMoveOption.moveLaneRequest))
            }
            return result
        }
    }

    return dispatch<any>(createRequestThunk(thunkParams))
}
